export const EVENT_NAME = {
  PAGEVIEW: 'PAGEVIEW',
  ACCOUNTCREATE: 'ACCOUNT_CREATE',
  LOGIN: 'LOGIN',
};
